var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRenameLarge = function SvgRenameLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12h5.64l3-3H1.5C.675 9 0 9.675 0 10.5S.675 12 1.5 12Zm21.735-6.015c.465-.48.765-1.14.765-1.86A2.618 2.618 0 0 0 21.375 1.5c-.72 0-1.38.3-1.86.765l-2.16 2.16L21.06 8.13l2.175-2.145ZM1.5 6h11.64l3-3H1.5C.675 3 0 3.675 0 4.5S.675 6 1.5 6Zm0 9c-.825 0-1.5.675-1.5 1.5 0 .72.525 1.29 1.2 1.44L4.14 15H1.5Zm14.925-9.645L6.39 15.39l3.705 3.705L20.13 9.06l-3.705-3.705ZM22.8 9.06 19.86 12h2.64c.825 0 1.5-.675 1.5-1.5 0-.72-.525-1.29-1.2-1.44ZM3 22.5l5.79-2.085-3.69-3.66L3 22.5ZM22.5 15h-5.64l-3 3h8.64c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5Z",
    fill: "#749282"
  })));
};
export default SvgRenameLarge;